<app-preloader *ngIf="isLoading"></app-preloader>
<app-img-header
  title="Marcas"
  alt="Daimler Truck"
  image="/assets/images/cotizador/intro.jpg"
> 
</app-img-header>
<main class="main" id="">
  <div id="detail">
    <div class="pageWidth">
      <div class="actionsWrapper">
        <button class="tertiary" (click)="createForm()"><i class="icon"></i> Nueva marca</button>
      </div>

      <!-- Tabla con marcas -->
      <div class="customTable marcas">
        <div class="header">
          <div class="cell nombre">Nombre</div>
          <!-- 
          <div class="cell codigo">Código</div>
          -->
          <div class="cell habilitado">Habilitado</div>
          <div class="cell acciones"></div>
        </div>

        <div class="row" *ngFor="let brand of data, let i = index">
          <div class="cell nombre">{{ brand.name }}</div>
          <!-- 
          <div class="cell codigo">{{ brand.brandCode }}</div>
          -->
          <div class="cell habilitado">{{ brand.enabled ? 'Sí' : 'No' }}</div>
          <div class="cell acciones">
            <a class="edit" tp="Editar" (click)="edit(brand)">Editar</a>
          <!--  <a class="delete" tp="Eliminar" (click)="openModalConfirmation(brand)">Eliminar</a>-->
          </div>
        </div>
      </div>
      <div class="actionsWrapper">
        <button class="tertiary" (click)="createForm()"><i class="icon"></i> Nueva marca</button>
      </div>
    </div>
  </div>
</main>

<ng-template #modalTemplate>
  <app-brand-template 
  [isEdit]="isEdit"
  [brandData]="selectedBrandData"
  (save)="onSaveBrand($event)"
  (update)="updateBrand($event)">
</app-brand-template>
</ng-template>
<ng-template #templateConfirmation>
  <app-template-confirmation
    [title]="title"
    [subtitle]="subtitle"
    [btn1]="btn1"
    [btn2]="btn2"
    (closeModal)="closeModal()"
    (actionBtn2)="deleteBrandById()"
  ></app-template-confirmation>
</ng-template>

<ng-template #template>
  <div class="wrapperG3">
    <div>
      <label>Nombre de la marca</label>
      <app-input
        [data]="searchName"
        (textSearch)="filter($event, 'name')"
        [resetInput]="reset"
      ></app-input>
    </div>
    <div>
      <label>Código de la marca</label>
      <app-input
        [data]="searchCode"
        (textSearch)="filter($event, 'name')"
        [resetInput]="reset"
      ></app-input>
    </div>
  </div>
  <div class="filtersActions">
    <button class="primary" (click)="search()">Buscar</button>
    <button class="secondary" (click)="resetFilters()">Limpiar filtros</button>
  </div>
</ng-template>
